module.exports = __webpack_public_path__ + "static/media/Vegan.f2823990.svg";